export default {
  methods: {
    /**
     * 取交集
     */
    getIntersection(A, B) {
      if ([...A, ...B].some(item => typeof item !== 'number' || isNaN(item))) return null
      const [a1, a2] = A;
      const [b1, b2] = B;
      // 计算交集的起点和终点
      const start = Math.max(a1, b1);
      const end = Math.min(a2, b2);
      // 判断是否有交集
      return start <= end ? [start, end] : null;
    },
    /**
     * 合并命中区间
     */
    mergeMultipleIntervals(intervals) {
      if (intervals.length === 0) return [];
      // 1. 按起点排序（如果起点相同，则按终点排序）
      intervals.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
      const merged = [intervals[0]];
      for (let i = 1; i < intervals.length; i++) {
        const [prevStart, prevEnd] = merged[merged.length - 1];
        const [curStart, curEnd] = intervals[i];
        if (prevEnd >= curStart) {
          // 有重叠，合并
          merged[merged.length - 1] = [prevStart, Math.max(prevEnd, curEnd)];
        } else {
          // 无重叠，直接加入结果
          merged.push([curStart, curEnd]);
        }
      }

      return merged;
    },
    /**
     * 设置命中文本高亮
     */
    setTextHighlight(hitList, sessionList) {
      if (!Array.isArray(hitList) || !Array.isArray(sessionList)) return
      const hitIndexs = this.mergeMultipleIntervals((hitList || []).reduce((hVal, hit) => {
        return [...hVal, ...(hit.keywords || []).reduce((kVal, keyword) => {
          return [...kVal, ...(keyword.indexes || []).map((iVal) => [iVal.begin, iVal.end - 1])]
        }, [])]
      }, []))
      for (const session of sessionList) {
        if (!hitIndexs.length) break
        let i = 0
        while (i < hitIndexs.length) {
          const intersection = this.getIntersection([session.globalIndexBegin, session.globalIndexEnd], hitIndexs[i])
          if (!intersection) {
            i += 1
            continue
          }
          const [, end] = intersection
          if (!session.hitItems) session.hitItems = []
          session.hitItems.push(intersection)
          if (end < hitIndexs[i][1]) {
            hitIndexs[i] = [end, hitIndexs[i][1]]
            i += 1
          } else {
            hitIndexs.shift()
          }
        }
        let formatContent = '';
        let lastIndex = 0;
        if (session.hitItems) {
          for (const [start, end] of session.hitItems) {
            const startIndex = start - session.globalIndexBegin
            const endIndex = end - session.globalIndexBegin + 1
            // 追加命中前的部分
            formatContent += session.content.slice(lastIndex, startIndex);
            const hitStr = session.content.slice(startIndex, endIndex)
            // 追加替换内容
            formatContent += `<span style="background-color: #3AB54A;color:#ffffff">${hitStr}</span>`;
            // 更新最后索引
            lastIndex = endIndex;
          }
        }
        formatContent += session.content.slice(lastIndex);
        session.formatContent = formatContent
      }
    }
  }
}
